module.exports = __webpack_public_path__ + "img/baoming.a7c0f65b.png";